module.exports = __webpack_public_path__ + "static/img/ctyiyuan1.e5023ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyiyuan1.png
// module id = lQf/
// module chunks = 5